import { PublicSponsorshipVoucherApi } from '@blank/api'
import { Link } from 'modules/common/components/Link/Link'
import { IconGift, IconTrash } from 'modules/common/components/_icons/icons'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { Trans } from 'next-i18next'

interface Props {
  publicSponsorshipVoucher: PublicSponsorshipVoucherApi
  onReset: () => void
}

export const SponsorshipVoucherPreview = ({
  onReset,
  publicSponsorshipVoucher,
}: Props) => {
  const { t } = useTranslation(['auth-components', 'common'])
  const { conditionsLink, refereeReward, voucherCode } =
    publicSponsorshipVoucher

  return (
    <div className="flex items-start rounded-xl border-2 border-primary bg-primary-90 p-4">
      <IconGift className="h-8 w-8 shrink-0 rounded-lg bg-primary p-1 text-white" />
      <span className="pl-3 pr-4">
        <Trans parent="p">
          {t('sponsorshipVoucherPreview.description', {
            refereeReward,
            voucherCode,
          })}
        </Trans>
        <Link className="mt-1 font-bold underline" href={conditionsLink}>
          {t('common:learnMore')}
        </Link>
      </span>

      <Button
        variant="none"
        color="danger"
        icon={<IconTrash />}
        className="mx-1"
        type="button"
        onClick={onReset}
      />
    </div>
  )
}
